/**
 * I18nProvider (I18N-T1) — the Suspense boundary for i18next's lazy namespace loading.
 *
 * With react.useSuspense enabled, components suspend until their namespace JSON has loaded.
 * This boundary (mounted in main.tsx around <App/>) shows the brand splash during that first
 * load. react-i18next uses the global i18n instance (initReactI18next), so no React context
 * provider is required — only the Suspense fallback.
 *
 * @module i18n/I18nProvider
 */
import { Suspense, type ReactNode } from 'react';
import Splash from '../components/ui/Splash';
import './config'; // ensure i18next is initialized before children render

export function I18nProvider({ children }: { children: ReactNode }): JSX.Element {
  return <Suspense fallback={<Splash />}>{children}</Suspense>;
}

export default I18nProvider;
